import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  max-width: 400px;
  margin-top: 50px;
  align-items: center;
  justify-content: center;

  img {
    max-width: 90px;
    object-fit: contain;
  }

  span {
    padding: 0 0 0 20px;
    font-size: 14px;
    line-height: 1.3;
    text-align: justify;
    font-variant: tabular-nums;
  }
`;

export const ImageWrapper = styled.div`
  min-width: 5.625rem;
  min-height: 5.625rem;
`;
